module.exports = __webpack_public_path__ + "img/footer.ab573657.png";